import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "70",
  height: "70",
  fill: "currentColor",
  viewBox: "0 0 70 70"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M47.759 41.956c6.517-10.744 4.608-25.01-5.078-33.548C31.92-1.077 15.634.104 6.303 11.045c-9.33 10.94-8.168 27.5 2.593 36.984a25.475 25.475 0 0 0 33.743.042l20.71 18.833a3.905 3.905 0 0 0 5.57-.404c1.43-1.676 1.252-4.212-.396-5.664l-20.764-18.88Zm-10.252-27.48c7.465 6.58 8.27 18.067 1.799 25.656-6.472 7.59-17.77 8.409-25.235 1.829-7.466-6.58-8.27-18.066-1.8-25.656 6.473-7.59 17.77-8.408 25.236-1.829Z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M0 0h70v70H0z" })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }